import {
  EQuantityFormatKey,
  IQuantityFormat,
  ITimeFormat
} from '../../StoreSettings.types';

import {
  ABBREVIATION_BOOLEAN_OPTIONS,
  ABBREVIATION_SEPARATOR_OPTIONS,
  QUANTITY_TO_TIME_KEY
} from './AbbreviationsSettingsV2.consts';
import {
  EAbbreviationDropdownType,
  IAbbreviationDropdownField,
  IAbbreviationDropdownOption,
  QuantityFieldPath,
  QuantityFieldValue,
  TimeFieldPath
} from './AbbreviationsSettingsV2.types';

export const getQuantityFieldPath = (
  sectionKey: EQuantityFormatKey,
  fieldKey: keyof IQuantityFormat
): QuantityFieldPath => `${sectionKey}.${fieldKey}`;

export const getTimeFieldPath = (
  sectionKey: EQuantityFormatKey,
  fieldKey: keyof ITimeFormat
): TimeFieldPath => `${QUANTITY_TO_TIME_KEY[sectionKey]}.${fieldKey}`;

export const getAbbreviationDropdownOptions = (
  field: IAbbreviationDropdownField
): IAbbreviationDropdownOption[] =>
  field.type === EAbbreviationDropdownType.BOOLEAN
    ? ABBREVIATION_BOOLEAN_OPTIONS
    : ABBREVIATION_SEPARATOR_OPTIONS;

export const getAbbreviationDropdownSelectedValue = (
  field: IAbbreviationDropdownField,
  rawValue: QuantityFieldValue | undefined
): string =>
  field.type === EAbbreviationDropdownType.BOOLEAN
    ? String(Boolean(rawValue))
    : String(rawValue);

export const parseAbbreviationDropdownValue = (
  field: IAbbreviationDropdownField,
  value: string
): QuantityFieldValue =>
  field.type === EAbbreviationDropdownType.BOOLEAN ? value === 'true' : value;
